import {
  createVideoUrlCryptoContext,
  decryptVideoUrlsInResponse,
} from './videoUrlCrypto';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

async function learningRequest(path, options = {}, containsVideoUrls = false) {
  const token = localStorage.getItem('cd_user_token');
  if (!token) {
    throw new Error('Please login to view your learning dashboard.');
  }

  const videoCrypto = containsVideoUrls
    ? await createVideoUrlCryptoContext()
    : null;
  const response = await fetch(`${API_BASE_URL}/learning/${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(videoCrypto?.headers || {}),
      ...(options.headers || {}),
    },
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.status === false) {
    const error = new Error(data.message || 'Unable to load learning data.');
    error.status = response.status;
    throw error;
  }

  return videoCrypto
    ? decryptVideoUrlsInResponse(data, videoCrypto.clientPrivateKey)
    : data;
}

export const getLearningDashboard = () => learningRequest('dashboard');

export const getLearningCourse = (courseId) =>
  learningRequest(`courses/${courseId}`);

export const getEncryptedLectureVideo = (lectureId, options = {}) =>
  learningRequest(`lectures/${encodeURIComponent(lectureId)}/video`, {
    method: 'POST',
    body: JSON.stringify({}),
    ...options,
  }, true);

export const updateLearningProgress = (courseId, lectureId, completed = true) =>
  learningRequest('progress', {
    method: 'POST',
    body: JSON.stringify({ courseId, lectureId, completed }),
  });